<app-not-found bgChars="503" errorTitle="Maintenance" *ngIf="platformBrowser">
  <p>We are doing some planned maintenance and will be back soon.</p>
  <br />
  <p class="legal">Note: This page will refresh automatically when we are back.</p>
</app-not-found>
